import Action from '../Action';
import VehicleEngineTypeService from '../../services/Util/VehicleEngineTypeService';
import { message } from 'antd';

export function addVehicleEngineType(body) {
	return (dispatch) => {
		VehicleEngineTypeService.add(body)
			.then((engineType) => {
				dispatch({ type: Action.POST_VEHICLE_ENGINE_TYPE, engineType: engineType.data });
				message.success('Vehicle Engine Type Added');
			})
			.catch((error) => message.error('Failed to add vehicle engine type!'));
	};
}

export function updateVehicleEgnineType(id, body) {
	return (dispatch) => {
		VehicleEngineTypeService.update(id, body)
			.then((engineType) => {
				dispatch({ type: Action.UPDATE_VEHICLE_ENGINE_TYPE, egnineType: engineType.data });
				message.success('Engine Type Updated');
			})
			.catch((error) => message.error('Failed to edit engine type!'));
	};
}

export function deleteVehicleEngineType(id) {
	return (dispatch) => {
		VehicleEngineTypeService.delete(id)
			.then((engineType) => {
				dispatch({ type: Action.DELETE_VEHICLE_ENGINE_TYPE, engineType: engineType.data });
				message.success('Engine Type Deleted');
			})
			.catch((error) => message.error('Failed to delete engine type!'));
	};
}
